<div class="modal fade" id="serviceExpenseGroupModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header border-0 pb-0">
        <h5 class="modal-title fw-bold">Unificar gastos</h5>
      </div>

      <div class="modal-body px-4 pt-2 pb-3">
        <p class="text-muted small mb-3">
          Se encontraron servicios con la misma unidad y operador. Selecciona los servicios con los que deseas compartir los gastos.
        </p>

        <div class="seg-list">

          <!-- Grupos con gastos existentes -->
          <ng-container *ngFor="let group of groupedServices; trackBy: trackByCode">

            <div class="seg-group-header" (click)="toggleGroupExpand($event, group.code)">
              <div class="d-flex align-items-center gap-2 flex-grow-1">
                <input type="checkbox" class="form-check-input mt-0"
                       [(ngModel)]="groupChecked[group.group_id]"
                       (click)="$event.stopPropagation()">
                <span class="seg-badge">{{ group.code }}</span>
                <span class="seg-group-label">
                  {{ group.services.length }} Servicio{{ group.services.length !== 1 ? 's' : '' }} compartiendo viáticos
                </span>
              </div>
              <svg class="seg-chevron" [class.seg-chevron--open]="expandedGroups[group.code]"
                   xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M6 9l6 6 6-6" stroke="#555" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>

            <div *ngIf="expandedGroups[group.code]" class="seg-group-body">
              <table class="seg-table">
                <thead>
                  <tr>
                    <th>Folio</th>
                    <th>Dirección destino</th>
                    <th>Fecha carga</th>
                    <th>Fecha descargue</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let s of group.services; trackBy: trackById" class="seg-row seg-row--readonly">
                    <td>{{ s.folio }}</td>
                    <td class="seg-td-ellipsis">{{ s.destination_address }}</td>
                    <td>{{ formatDateTime(s.upload_date, s.charging_hour) }}</td>
                    <td>{{ formatDateTime(s.download_date, s.download_time) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </ng-container>

          <!-- Servicios sin grupo: checkbox individual -->
          <ng-container *ngIf="ungroupedServices.length > 0">
            <table class="seg-table seg-table--ungrouped">
              <thead>
                <tr>
                  <th style="width:36px"></th>
                  <th>Folio</th>
                  <th>Dirección destino</th>
                  <th>Fecha carga</th>
                  <th>Fecha descargue</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let s of ungroupedServices; trackBy: trackById"
                    (click)="stopAndToggleService($event, s.service_id)" class="seg-row">
                  <td>
                    <input type="checkbox" class="form-check-input"
                           [(ngModel)]="serviceChecked[s.service_id]"
                           (click)="$event.stopPropagation()">
                  </td>
                  <td>{{ s.folio }}</td>
                  <td class="seg-td-ellipsis">{{ s.destination_address }}</td>
                  <td>{{ formatDateTime(s.upload_date, s.charging_hour) }}</td>
                  <td>{{ formatDateTime(s.download_date, s.download_time) }}</td>
                </tr>
              </tbody>
            </table>
          </ng-container>

        </div>
      </div>

      <div class="modal-footer border-0 justify-content-center gap-3 pb-4">
        <button type="button" class="btn btn-outline-secondary rounded-pill px-4" (click)="skip()">
          No unificar
        </button>
        <button type="button" class="btn btn-primary rounded-pill px-4 d-flex align-items-center gap-2"
                (click)="confirm()" [disabled]="selectedCount === 0">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M9.14339 10.691L9.35031 10.4841C11.329 8.50532 14.5372 8.50532 16.5159 10.4841C18.4947 12.4628 18.4947 15.671 16.5159 17.6497L13.6497 20.5159C11.671 22.4947 8.46279 22.4947 6.48405 20.5159C4.50532 18.5372 4.50532 15.329 6.48405 13.3503L6.9484 12.886" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M17.0516 11.114L17.5159 10.6497C19.4947 8.67095 19.4947 5.46279 17.5159 3.48405C15.5372 1.50532 12.329 1.50532 10.3503 3.48405L7.48405 6.35031C5.50532 8.32904 5.50532 11.5372 7.48405 13.5159C9.46279 15.4947 12.671 15.4947 14.6497 13.5159L14.8566 13.309" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          Unificar ({{ selectedCount }})
        </button>
      </div>

    </div>
  </div>
</div>
